import { translateTextNode, $t } from '@/client/directives/i18n';
export default {
    install: (app) => {
        app.config.globalProperties.$t = $t;
        app.directive('i18n', {
            mounted: (el, binding) => {
                el.setAttribute('tm-has-i18n', 'true');
                translateTextNode(el, binding);
            },
            updated: translateTextNode,
        });
    },
};
